import Validator from 'validatorjs/src/validator';
import {translate} from '../utils/localizationUtility';

export const validateEmail = (email = '') => {
    return !!email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
};

export const validatePhone = (phone = '') => {
    return /^[0-9\-+]{9,15}$/.test(phone);
};

export const customError = (oldMessage, newMessage) => {
    const message = oldMessage || '';
    if (message.includes('required')) {
        return newMessage;
    }
    return message;
};

export const registerValidation = () => {
    Validator.register('password', (value) => {
        return value.match(/^.{6,}$/);
    }, translate('general.validation.password'));

    Validator.register('phone', (value) => {
        return value.match(/^[0-9\-+\s]{9,15}$/);
    }, translate('general.validation.phone'));
};
